<template>
    <c-dialog ref="dialog" title="背贴码跟踪" width="1200" height="1000" enable-flex mask-close :button="false">
		<div class="scan-input flex-center-cross">
			<c-input ref="codeInput" v-model="scanCode" class="flex-grow" placeholder="请扫描或输入背贴码" style="width: auto; height: 50px; padding: 0 5px; border-radius: 6px 0 0 6px;" @keyup.enter.native="detail(scanCode)">
				<template #appendIcon><i class="tf-scan" style="font-size: 20px; color: #bbb;"></i></template>
			</c-input>
			<c-button color="main" style="width: 60px; height: 50px; padding: 0; border-radius: 0 6px 6px 0; font-size: 24px;" @click="detail(scanCode)"><i class="tf-search"></i></c-button>
		</div>
        <c-empty v-if="emptyState" message="请扫描或输入背贴码"></c-empty>
        <template v-else>
            <c-detail class="m-detail-table" column="3" style="padding-top: 0;">
                <c-detail-item label="商品信息">
                    <c-state tag async dict="LEVEL_TYPE" :value="detailData.level_type"></c-state>
                    {{productName}}

                </c-detail-item>
                <c-detail-item label="背贴码">
                    {{detailData.produce_unique_code}}
                </c-detail-item>
                <c-detail-item label="供应商">
                    {{detailData.supplier_name||'-'}}
                </c-detail-item>
                <c-detail-item label="采购价">
                    ￥{{detailData.purchase_price||'-'}}
                </c-detail-item>
                <c-detail-item label="IMEI码">
                    {{detailData.produce_imei}}
                </c-detail-item>
                <c-detail-item label="采购人">
                    {{detailData.purchase_user_realname||'-'}}
                </c-detail-item>
                <c-detail-item label="维修价">
                    ￥{{detailData.repair_cost||'-'}}
                </c-detail-item>
                <c-detail-item label="在库时长">
                    {{stockDurationText}}
                </c-detail-item>
                <c-detail-item label="当前部门">
                    {{detailData.current_duty_dept_name||'-'}}
                </c-detail-item>
                <c-detail-item label="售价">
                    ￥{{detailData.retail_price||'-'}}
                </c-detail-item>
                <c-detail-item label="入库时间">
                    {{stockInTime||'-'}}
                </c-detail-item>
                <template v-for="(item, i) in customFields">
                    <c-detail-item v-if="item.attribute_id!=detailData.color_id && item.attribute_id!=detailData.memory_id" :key="i" :label="item.attribute_name">
                        <span class="field-value">{{ item.attribute_value }}</span>
                    </c-detail-item>
                </template>
            </c-detail>

            <template v-if="logList && timeList">
                <c-tab-list :tabs="tabs" @change="data => currentTab = data.value"></c-tab-list>

                <!-- 跟踪记录：左侧时间轴（全局倒序后按操作类型大类切分连续小分组）+ 右侧备注/维修卡片 -->
                <div v-if="currentTab == 1" class="track flex">
                    <div class="timeline flex-grow">
                        <c-empty v-if="!timelineNodes.length" height="400"></c-empty>
                        <div v-for="(node, i) in timelineNodes" :key="i" class="node" :class="{'z-crt': i == 0}">
                            <span class="dot"></span>
                            <div class="node-head flex-center-cross">
                                <span class="node-title">{{node.title}}</span>
                                <span class="node-tag">{{node.tag}}</span>
                                <span class="node-date">{{node.date}}</span>
                            </div>
                            <div class="node-sub">
                                <span>{{node.user_name||'-'}}（{{node.dept_name||'-'}}）</span>
                                <span v-if="node.stage">{{node.stage}}</span>
                            </div>
                            <ul v-if="node.logs.length" class="node-log">
                                <li v-for="(log, j) in node.logs" :key="j">
                                    <span>{{log.create_date}}</span>
                                    <span class="log-user">{{log.operator_user_name}}</span>
                                    <span>{{log.action_desc}}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="side">
                        <!-- 备注信息：聚合各来源单据创建时填写的备注（线下采购/质检维修销售调拨/分润调拨/线下销售） -->
                        <div class="side-card">
                            <div class="side-head"><i class="tf tf-edit"></i>备注信息</div>
                            <div class="side-body">
                                <p v-if="!remarkList.length" class="side-empty">暂无备注信息</p>
                                <ul v-else class="remark-list">
                                    <li v-for="(item, i) in remarkList" :key="i">
                                        <div class="r-head flex-center-cross">
                                            <span class="dot-mini"></span>
                                            <span class="r-user">{{item.create_user_realname||'-'}}</span>
                                            <span class="node-tag">{{item.source_name}}</span>
                                            <span class="r-date">{{item.create_date}}</span>
                                        </div>
                                        <p class="r-items">{{item.remark}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!-- 维修记录：维修/送修逐条展示，明细展开到分项金额 -->
                        <div class="side-card">
                            <div class="side-head"><i class="tf tf-repair"></i>维修记录</div>
                            <div class="side-body">
                                <c-empty v-if="!sortedRepairCards.length" height="160"></c-empty>
                                <ul v-else class="repair-list">
                                    <li v-for="(card, i) in sortedRepairCards" :key="i">
                                        <div class="r-head flex-center-cross">
                                            <span class="dot-mini"></span>
                                            <span class="r-user">{{card.user_name||'-'}}</span>
                                            <span v-if="card.kind == 2" class="node-tag">送修</span>
                                            <span class="r-date">{{card.date}}</span>
                                        </div>
                                        <p class="r-items">{{itemText(card)}}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 停留时长：按部门筛选 + 本页合计 -->
                <div v-else class="time">
                    <ul class="tab flex">
                        <li v-for="(item,i) in timeTabList" :key="i" :class="{'z-crt': currentTimeTab == item}" @click="currentTimeTab = item">{{item || '全部'}}</li>
                    </ul>
                    <c-empty v-if="!compTimeList.length" height="400"></c-empty>
                    <table v-else class="time-table">
                        <thead>
                            <tr>
                                <th>姓名</th>
                                <th>所属部门</th>
                                <th>停留时长</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in compTimeList" :key="i">
                                <td>{{item.operator_user_name}}</td>
                                <td>{{item.operator_dept_name}}</td>
                                <td :class="{'z-warn': isCurrentStay(item)}">{{stayText(item)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td>本页合计：</td>
                                <td></td>
                                <td>{{totalStayText}}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </template>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'produceUniqueCodeDetail',

    props: {
        produce_unique_code: [String, Number]
    },

    data() {
        return {
            emptyState: !this.produce_unique_code,
			scanCode: '',
            detailData: {},
            customFields:undefined,

            tabs: [{
                name: '跟踪记录',
                value: 1
            }, {
                name: '停留时长',
                value: 2
            }],
            currentTab: 1,

            logList: null,

            timeTabList: [],
            currentTimeTab: '',
            timeList: null,

            /**维修/送修记录卡片（kind：1维修 2送修），明细异步回填 */
            repairCards: [],
            /**聚合备注列表（线下采购/质检维修销售调拨/分润调拨/线下销售 单据创建时填写） */
            remarkList: [],
            /**维修项字典 value→name 映射 */
            repairItemMap: {}
        }
    },

    computed: {
        productName() {
            return [this.detailData.brand_name, this.detailData.spu_model_name, this.detailData.color_name, this.detailData.memory_name].filter(item => item).join(' ');
        },

        /**入库时间取最近一次入库，缺失时回退首次入库 */
        stockInTime() {
            return this.detailData.latest_stock_in_time || this.detailData.first_stock_in_time || '';
        },

        /**在库时长：仅在库（main_state=3）时计算距最近一次入库的历时，已出库/未入库显示- */
        stockDurationText() {
            if (this.detailData.main_state != 3 || !this.stockInTime) return '-';
            let diff = Date.now() - new Date(this.stockInTime).getTime();
            if (isNaN(diff) || diff < 0) return '-';
            let days = Math.floor(diff / 86400000);
            return days >= 1 ? days + '天' : Math.max(1, Math.round(diff / 3600000)) + '小时';
        },

        /**当前部门：最新一条操作日志的作业部门 */
        currentDeptName() {
            return this.lastOperateLog ? this.lastOperateLog.operator_dept_name : '';
        },

        /**最新一条操作日志（备注类日志不参与当前阶段判定） */
        lastOperateLog() {
            let list = (this.logList || []).filter(item => item.log_type == 1);
            return list.length ? list[list.length - 1] : null;
        },

        /**
         * 时间轴节点：操作日志先按id全局倒序（自增主键与写入顺序一致，create_date仅分钟精度不可靠），
         * 再将相邻同大类（ActionTypeEnum分段，初次入库单独key）的日志切分为一个小分组节点，
         * 同一大类在不同时间段可出现多个节点；节点顺序即全局倒序（当前节点置顶），节点内日志按事件发生顺序升序展示
         */
        timelineNodes() {
            if (!this.logList) return [];
            let logs = this.logList.filter(item => item.log_type == 1)
                .slice().sort((a, b) => (b.id || 0) - (a.id || 0));
            let groups = [];
            let cur = null;
            logs.forEach(item => {
                let cat = this.timelineCategory(item.action_type);
                if (!cur || cur.key != cat.key) {
                    cur = {key: cat.key, title: cat.title, tag: cat.tag, stage: cat.stage, logs: []};
                    groups.push(cur);
                }
                cur.logs.push(item);
            });
            groups.forEach(node => {
                node.logs.reverse();
                let latest = node.logs[node.logs.length - 1];
                node.date = latest.create_date;
                node.user_name = latest.operator_user_name;
                node.dept_name = latest.operator_dept_name;
            });
            return groups;
        },

        /**维修/送修卡片按时间倒序展示，同分钟时按id倒序兜底 */
        sortedRepairCards() {
            return this.repairCards.slice().sort((a, b) => (b.date || '').localeCompare(a.date || '') || (b.id || 0) - (a.id || 0));
        },

        compTimeList() {
            return this.timeList ? this.timeList.filter(item => !this.currentTimeTab || this.currentTimeTab == item.operator_dept_name) : null;
        },

        /**本页合计：筛选后停留天数求和（total_stay_days与total_stay_hours为同一时长的不同单位，不可叠加） */
        totalStayText() {
            let list = this.compTimeList || [];
            if (!list.length) return '-';
            let days = list.reduce((acc, cur) => acc + (Number(cur.total_stay_days) || 0), 0);
            let v = Math.round(days * 10) / 10;
            return v >= 1 ? v + '天' : Math.round(days * 24) + '小时';
        }
    },

    methods: {
        /**
         * 操作类型大类映射（与ActionTypeEnum分段一致）：
         * 0~2采集/绑定/取消绑定归条码采集，3初检+4入库归初次入库单独成节点，
         * 其余按 -1、5~8出入库 / 11~18质检（含18串号变更） / 21~26维修 / 31~40销售 / 41~48分润调拨 分组，
         * 区间外未知类型归入其他，避免落错大类
         */
        timelineCategory(type) {
            if (type >= 0 && type <= 2) return {key: 'collect', title: '条码采集', tag: '采集', stage: '采集 → 绑定'};
            if (type == 3 || type == 4) return {key: 'stock_in', title: '初次入库', tag: '入库', stage: '入库 → 初检'};
            if (type >= -1 && type <= 8) return {key: 'stock', title: '出入库操作', tag: '出入库', stage: '入库 → 出库'};
            if (type >= 11 && type <= 18) return {key: 'quality', title: '质检', tag: '质检', stage: '接驳 → 质检'};
            if (type >= 21 && type <= 26) return {key: 'repair', title: '维修', tag: '维修', stage: '接驳 → 维修'};
            if (type >= 31 && type <= 40) return {key: 'sale', title: '销售', tag: '销售', stage: '接驳 → 销售'};
            if (type >= 41 && type <= 48) return {key: 'profit', title: '分润调拨', tag: '分润', stage: '在库 → 调拨'};
            return {key: 'other', title: '其他操作', tag: '其他', stage: ''};
        },

        /**维修项字典名 */
        repairItemName(id) {
            return this.repairItemMap[id] || id;
        },

        /**维修卡片明细文案：分项名+金额竖线分隔；明细未返回时回退列表接口的聚合文本 */
        itemText(card) {
            if (card.items.length) {
                return card.items.map(item => this.repairItemName(item.repair_item) + ' ￥' + item.repair_amount).join(' | ');
            }
            return card.fallback || '-';
        },

        /**停留时长文案 */
        stayText(item) {
            return item.total_stay_days >= 1 ? item.total_stay_days + '天' : item.total_stay_hours + '小时';
        },

        /**当前停留阶段（最新操作日志的作业人+部门）标红提示仍在累计 */
        isCurrentStay(item) {
            let last = this.lastOperateLog;
            return !!last && !!item.operator_user_name
                && item.operator_user_name == last.operator_user_name
                && item.operator_dept_name == last.operator_dept_name;
        },

        /**加载维修项字典（value→name） */
        loadRepairItemDic() {
            if (Object.keys(this.repairItemMap).length) return;
            this.request({
                url: '/system/dic/options',
                data: {dic_type_code: 'REPAIR_ITEM'},
                success: data => {
                    (data || []).forEach(item => {
                        this.$set(this.repairItemMap, item.value, item.name);
                    });
                }
            });
        },

        /**加载聚合备注列表（数据来源：线下采购/质检维修销售调拨/分润调拨/线下销售 单据创建时填写的备注） */
        loadRemarks(productCodeId, produceUniqueCode) {
            this.request({
                url: '/productCode/remark/listByCodeId',
                data: {
                    produce_unique_code_id: productCodeId,
                    produce_unique_code: produceUniqueCode
                },
                success: data => {
                    this.remarkList = data || [];
                }
            });
        },

        /**加载维修/送修记录卡片，明细金额走各自详情接口回填 */
        loadRepairCards(productCodeId) {
            this.repairCards = [];
            this.request({
                url: '/repair/record/listByProduct',
                data: {produce_unique_code_id: productCodeId},
                success: data => {
                    let list = (data && data.obj) ? data.obj : (data || []);
                    list.forEach(record => {
                        let card = {kind: 1, id: record.id, user_name: record.repair_user_name || record.create_user_name, date: record.create_date, items: [],
                            fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
                        this.repairCards.push(card);
                        this.request({
                            url: '/repair/record/detail',
                            data: {id: record.id},
                            success: d => {
                                card.items = (d && d.details) || [];
                            }
                        });
                    });
                }
            });
            this.request({
                url: '/repair/delivery/list',
                data: {produce_unique_code_id: productCodeId, page_size: 100},
                success: data => {
                    let list = (data && data.obj) ? data.obj : (data || []);
                    list.forEach(record => {
                        let card = {kind: 2, id: record.id, user_name: record.sender_user_name || record.create_user_name, date: record.delivery_date || record.create_date, items: [],
                            fallback: record.repair_item_name ? record.repair_item_name + ' ￥' + record.repair_amount : ''};
                        this.repairCards.push(card);
                        this.request({
                            url: '/repair/delivery/detail',
                            data: {id: record.id},
                            success: d => {
                                card.items = (d && d.details) || [];
                            }
                        });
                    });
                }
            });
        },

        /**
         * 加载详情
         */
        detail(code){
            if (!code.trim()) {
                this.$message({
                    message: '请扫描或输入背贴码'
                });
                return;
            }
            this.request({
                url: '/productCode/queryByCode',
                data: {
                    produce_unique_code: code.trim()
                },
                loading: true,
                success: data => {
                    this.emptyState = false;
                    this.detailData = data;
                    if (this.detailData.custom_fields_value_json && this.detailData.custom_fields_value_json.attribute){
                        this.customFields = this.detailData.custom_fields_value_json.attribute;
                    }else if (this.detailData.initial_inspection_json && this.detailData.initial_inspection_json.attribute){
                        this.customFields = this.detailData.initial_inspection_json.attribute
                    }

                    this.currentTab = 1;
                    this.logList = null;
                    this.currentTimeTab = '';
                    this.timeTabList = [];
                    this.timeList = null;
                    this.repairCards = [];
                    this.remarkList = [];
                    this.request({
                        url: '/productCode/log/listByCodeId',
                        data: {
                            produce_unique_code_id: data.id
                        },
                        success: data => {
                            this.logList = data;
                        }
                    });
                    this.request({
                        url: '/productCode/downtime/listByCodeId',
                        data: {
                            produce_unique_code_id: data.id
                        },
                        success: data => {
                            let list = data.map(item => item.operator_dept_name).filter(item => item).reduce((acc, cur) => {
                                if(!acc.includes(cur)) acc.push(cur);
                                return acc;
                            }, [])
                            this.timeTabList = [''].concat(list);
                            this.timeList = data;
                        }
                    });
                    this.loadRepairItemDic();
                    this.loadRepairCards(data.id);
                    this.loadRemarks(data.id, data.produce_unique_code || this.produce_unique_code);
                },
                complete: () => {
                    this.scanCode = ''
                }
            });
        },
        open(data) {
            this.produce_unique_code && this.detail(this.produce_unique_code);
            this.$refs.dialog.open();
        }
    }
}
</script>

<style lang="stylus" scoped>
	.scan-input
		padding 24px 150px 28px

    .track {
        gap: 14px;
        padding: 18px 26px 10px;
    }

    .node-tag {
        border-radius: 4px;
        border: 1px solid #B9C8FF;
        padding: 0 6px;
        margin-left: 8px;
        line-height: 18px;
        font-size: 12px;
        color: var(--color-main);
    }

    .timeline {
        min-width: 0;

        .node {
            position: relative;
            padding: 0 0 18px 18px;

            &:before {
                content: '';
                position: absolute;
                left: 4px;
                top: 16px;
                bottom: -2px;
                width: 1px;
                background: #E5E8F0;
            }

            &:last-child:before {
                display: none;
            }

            .dot {
                position: absolute;
                left: 0;
                top: 5px;
                box-sizing: border-box;
                width: 9px;
                height: 9px;
                border-radius: 50%;
                border: 2px solid #C0C6D4;
                background: #fff;
            }

            &.z-crt {
                .dot {
                    border-color: var(--color-main);
                    box-shadow: 0 0 0 2px rgba(61, 94, 255, .15);
                }

                .node-title {
                    color: var(--color-main);
                }
            }
        }

        .node-head {
            gap: 2px;

            .node-title {
                font-size: 14px;
                font-weight: 600;
                color: #333;
            }

            .node-date {
                margin-left: auto;
                font-size: 12px;
                color: #999;
            }
        }

        .node-sub {
            display: flex;
            gap: 24px;
            margin: 10px 0;
            font-size: 13px;
            color: #666;
        }

        .node-log {
            border: 1px solid #eee;
            border-radius: 4px;
            background: #F9F9F9;

            li {
                padding: 10px 12px;
                line-height: 18px;
                font-size: 12px;
                color: #666;
                word-break: break-word;

                & + li {
                    border-top: 1px solid #eee;
                }
            }

            .log-user {
                margin: 0 .5em;
                color: #000;
            }
        }
    }

    .side {
        display: flex;
        flex-direction: column;
        align-self: flex-start;
        gap: 14px;
        position: sticky;
        top: 18px;
        width: 300px;
        flex-shrink: 0;

        &-card {
            display: flex;
            flex-direction: column;
            border-radius: 4px;
            border: 1px solid #EBEDF2;
        }

        &-head {
            border-radius: 4px 4px 0 0;
            padding: 12px 12px;
            font-size: 13px;
            font-weight: 600;
            color: #333;
            background: #F9F9F9;

            .tf {
                margin-right: 6px;
                color: #666;
            }
        }

        &-body {
            flex-grow: 1;
            padding: 10px 12px;
        }

        &-empty {
            padding: 40px 0;
            text-align: center;
            font-size: 12px;
            color: #ccc;
        }
    }

    .repair-list, .remark-list {
        li {
            & + li {
                border-top: 1px solid #F0F1F4;
            }

            padding: 12px 0;
        }

        .r-head {
            .dot-mini {
                width: 6px;
                height: 6px;
                border-radius: 50%;
                margin-right: 6px;
                background: var(--color-main);
            }

            .r-user {
                font-size: 13px;
                font-weight: 600;
                color: var(--color-main);
            }

            .node-tag {
                margin-left: 6px;
            }

            .r-date {
                margin-left: auto;
                font-size: 12px;
                color: #999;
            }
        }

        .r-items {
            margin: 6px 0 0 12px;
            font-size: 12px;
            color: #333;
            word-break: break-word;
        }
    }

    .tab {
        gap: 10px;
        padding: 0 26px;
        margin-top: 18px;

        li {
            border-radius: 4px;
            padding: 0 8px;
            line-height: 28px;
            font-size: 14px;
            color: var(--color-main);
            background: #F5F7FF;
            cursor: pointer;

            &:hover, &.z-crt {
                color: #fff;
                background: var(--color-main);
            }
        }
    }

    .time-table {
        border-spacing: 0;
        width: calc(100% - 52px);
        margin: 10px 26px 16px;

        th, td {
            border: 1px solid #EBEDF2;
            padding: 0 12px;
            line-height: 36px;
            font-size: 13px;
            text-align: left;
            color: #333;
        }

        th {
            background: #F9F9F9;
        }

        td.z-warn {
            color: #F5222D;
        }

        tfoot td {
            background: #F2FBEC;
        }
    }
</style>
